import { defaultConfig, Http } from '@/services/HttpService/HttpService';
import type { HttpService } from '@/services/HttpService/HttpService';

export const standardHttpService: HttpService = new Http(defaultConfig);
